'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../providers/ClaimBuilder/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemSelectionTitle = () => {
  const {
    state: {
      claimEligibilityInfo,
      itemClaims
    }
  } = index.useClaimBuilder();
  const {
    claimsSelectionTitleItem,
    claimsSelectionTitleItemItemsSelected,
    claimsSelectionTitleItemNoEligibility
  } = nthHookTranslations.useTranslations();
  const {
    items
  } = claimEligibilityInfo ?? {};
  if (!items) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const totalClaimableItemQuantity = Object.keys(items).reduce((total, uid) => total + (items[uid].maxClaimableQuantity ?? 0), 0);
  let title = claimsSelectionTitleItem;
  if (totalClaimableItemQuantity === 0) {
    title = claimsSelectionTitleItemNoEligibility;
  } else if (Object.keys(itemClaims).length) {
    title = claimsSelectionTitleItemItemsSelected;
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, title);
};
var ItemSelectionTitle$1 = nthHookTranslations.withTranslationsProvider(ItemSelectionTitle, {
  translationKeys: ['claimsSelectionTitleItem', 'claimsSelectionTitleItemItemsSelected', 'claimsSelectionTitleItemNoEligibility']
});

exports["default"] = ItemSelectionTitle$1;
